import Verify30DayHoldModal from './Verify30DayHoldModal';

export default Verify30DayHoldModal;
